import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const customerService = {
  getCustomers: (params = {}) =>
    axios.get(`${API_URL}/api/customers`, { ...authHeader(), params: { limit: 200, ...params } })
      .then(r => Array.isArray(r.data.customers) ? r.data.customers : []),
};

export default customerService;
